import { isAxiosError } from 'axios';

/**
 * API の 404 応答を「データなし（null）」として扱うための Promise catch ハンドラ。
 *
 * 404 以外のエラーは再 throw するため、ErrorBoundary による上流ハンドリングが維持される。
 * 使用例: `fetcher().catch(nullifyNotFound)`
 *
 * @param e - catch されたエラー
 * @returns null（404 応答の場合のみ）
 */
export const nullifyNotFound = (e: unknown): null => {
  if (isAxiosError(e) && e.response?.status === 404) return null;
  throw e;
};
